import React from 'react';

const NotFound = () => {
  return (
    <div className="panel-style flex items-center justify-center min-h-[75vh] p-6 text-[var(--text-color)]">
      <div className="text-center max-w-2xl">
        {/* Glitchy 404 text */}
        <div className="glitch-container mb-6">
          <h1 className="text-8xl font-bold panel-heading text-center glitch" data-text="404">
            404
          </h1>
          <p className="text-xl mt-2">oopsie woopsie!</p>
        </div>
        
        {/* Sad Pixelore image with animation */}
        <div className="relative w-48 h-48 mx-auto mb-8">
          <img 
            src="https://pixelore.s3.eu-central-003.backblazeb2.com/Avis/sadpixelore.png"
            alt="Pixelore is sad" 
            className="w-full h-full object-contain animate-bounce-slow"
          />
          <div className="absolute -bottom-2 left-0 right-0 text-center text-retrowhite">
            (╥﹏╥)
          </div>
        </div>
        
        {/* Fun message */}
        <div className="bg-retropurple border-2 border-retroyellow rounded-lg p-6 shadow-retro">
          <h2 className="text-2xl font-bold text-retroyellow mb-3">
            Page went on an adventure!
          </h2>
          <p className="text-retrowhite mb-4">
            The page you're looking for either got lost in the Pixels universe 
            or was eaten by a mischievous Silky! 
          </p>
          <p className="text-retrowhite">
            Try heading back to <a href="/" className="text-retroblue hover:underline">safety</a> or check if you typed the URL right!
          </p>
        </div>
        
        {/* Fun facts */}
        <div className="mt-8 text-retrogreen text-sm">
          <p>Fun fact: This 404 page is 100% more adorable than most!</p>
        </div>
      </div>
    </div>
  );
};

export default NotFound;